<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">发票管理</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">发票信息管理</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">发票信息管理</div>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-warn">
          <p>请放心填写发票信息，三丰云不会将这些信息对外披露或向第三方提供。</p>
        </div>
        <div class="ub-box z-margin-bottom-20-precent z-margin-top-20-precent">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addInvoice">新增发票信息</el-button>
        </div>
        <div class="clearfix">
          <el-table :data="invoiceList" highlight-current-row tooltip-effect="light" v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="taitou" label="发票抬头" align="left" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ktype" label="开具类型" align="left">
            </el-table-column>
            <el-table-column prop="ftype" label="发票类型" align="left">
            </el-table-column>
            <el-table-column prop="nsrsbh" label="税务登记号" align="left">
            </el-table-column>
            <el-table-column prop="caozuo" label="操作" align="left">
              <template slot-scope="scope">
                <router-link :to="'/invoiceedit'+'/'+scope.row.id" class="z-color-a">修改</router-link>
                &nbsp;&nbsp;
                <span class="z-color-a z-curPonit" @click="DelInvoice(scope.row.id)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="20" :total="total" class="pull-left" style="margin-bottom: 20px;">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total"
                         style="margin-bottom: 20px;">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import caiwuService from 'business/caiwuService.js'
  export default {
    data() {
      return {
        listLoading:false,
        invoiceList: [],
        count:20,
        total:0,
        page:1,
      }
    },
    components:{

    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchInvoice()
    },
    methods:{
      async SearchInvoice() {
        this.listLoading = true
        let data = 'cmd=invoice_mod_list'
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          /*this.total = vueData.allcount*/
          this.invoiceList = vueData.msg.map((item, index) => {
            return {
              id:item.id,
              taitou:item.taitou,
              ktype:item.fplx === '0' ? '个人' : '企业',
              ftype:item.fplx === '2' ? '增值税专用发票' : '增值税普通发票',
              nsrsbh:item.nsrsbh,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async DelInvoice(id) {
        MessageBox.confirm('确定要删除该发票记录吗?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=invoice_mod_del'+
            '&id='+ id
          this.dialogLoading = true
          let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {
                self.SearchInvoice()
              }})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchBmd()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchBmd()
      },
      addInvoice() {
        this.$router.push('/invoiceadd')
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .auth-form .el-input {
    width: 440px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/caiwu/invoiceinfo.vue